// src/utils/calculators.js

export const calculateLiquidFull = (data) => {
    const { weight, dehydration, isBicarb, isAbnormal, isHepatit, aminoType } = data;
    
    // Java: double resultBase = (dehydration / 100) * (weight * 1000);
    const resultBase = (dehydration / 100) * (weight * 1000);

    // Java: double liquidPart = hepatitCheckbox.isChecked() ? Math.ceil(resultBase / 2) : Math.ceil(resultBase / 3);
    const liquidPart = isHepatit ? Math.ceil(resultBase / 2) : Math.ceil(resultBase / 3);

    let guide = "";
    if (isHepatit) {
        // Java: guide = String.format("%%0.9 NaCl: %.0f ml\n%%5 Dekstroz: %.0f ml", liquidPart, liquidPart);
        guide = `%0.9 NaCl: ${liquidPart} ml\n%5 Dekstroz: ${liquidPart} ml`;
    } else {
        // Java: guide = String.format("%%0.9 NaCl: %.0f ml\n%%5 Dekstroz: %.0f ml\nLaktat Ringer: %.0f ml", liquidPart, liquidPart, liquidPart);
        guide = `%0.9 NaCl: ${liquidPart} ml\n%5 Dekstroz: ${liquidPart} ml\nLaktat Ringer: ${liquidPart} ml`;
    }

    let aminoAmount = 0;
    let showMetabolaseWarning = false;

    if (isAbnormal) {
        switch (aminoType) {
            case "Metabolase":
                aminoAmount = 4 * weight; // Java: 4 * weight
                guide += `\n+ Metabolase: ${parseInt(aminoAmount)} ml`;
                showMetabolaseWarning = true;
                break;
            case "Neoton":
                aminoAmount = Math.min(50, 10 * weight); // Java: Math.min(50, 10 * weight)
                guide += `\n+ Neoton: ${parseInt(aminoAmount)} ml`;
                break;
            case "Duphalite":
                aminoAmount = 10 * weight; // Java: 10 * weight
                guide += `\n+ Duphalite: ${parseInt(aminoAmount)} ml`;
                break;
        }
    }

    // Bikarbonat Hesaplama (Java'daki mantık)
    let bicarbMg = 0;
    let bicarbMl = 0;
    if (isBicarb) {
        bicarbMg = (dehydration / 100) * (weight * 1000) * 0.8; // Java: * 0.8
        bicarbMl = bicarbMg / 84; // Java: mg / 84
    }

    return {
        totalFluid: Math.round(resultBase + aminoAmount),
        bicarbMg: bicarbMg.toFixed(2),
        bicarbMl: bicarbMl.toFixed(2),
        guide: guide + "\nuygulanması önerilir.", // Java: guide + "\nuygulanması önerilir."
        showMetabolaseWarning
    };
};

// src/utils/calculators.js sonuna eklenecek:

export const calculateShockFluid = (data) => {
    const { weight, dehydration, condition } = data;
    
    // Java: double totalNeed = (dehydration / 100) * (weight * 1000);
    const totalNeed = (dehydration / 100) * (weight * 1000);
    let resultMessage = "";

    if (condition === 'kidney') {
        const liq30kristal = weight * 20;
        resultMessage = `Böbrek Yetmezliği Protokolü:\n\nİlk 30 dakikada: ${liq30kristal} ml kristaloid (İzotonik, RL, %5 Dekstroz) I.V. verilir.\n\nTakip eden süre: ${totalNeed - liq30kristal} ml sıvı verilmelidir.\n\nUYARI: Kolloid sıvılar (Dekstran vb.) KONTRAENDİKEDİR.`;
    } 
    else if (condition === 'hepatit') {
        const liq30kristal = weight * 20;
        const liq30kolloid = weight * 10;
        resultMessage = `Karaciğer Yetmezliği Protokolü:\n\nİlk 30 dakikada: ${liq30kristal} ml kristaloid (İzotonik, %5 Dekstroz) I.V. verilir.\n\nTakip eden 60 dakikada: ${liq30kolloid} ml kolloid (HES vb.) verilmelidir.\n\nGeri kalan süre: ${totalNeed - liq30kristal - liq30kolloid} ml kristaloid ile tamamlanır.\n\nUYARI: Laktat Ringer KONTRAENDİKEDİR.`;
    } 
    else if (condition === 'headtrauma') {
        const liq30kristal = weight * 20;
        const mannitolmg = weight * 1; // 1g/kg hesabı
        const mannitolliq = mannitolmg * 0.2; // %20'lik mannitol için
        resultMessage = `Kafa Travması Protokolü:\n\nİlk 30 dakikada: ${liq30kristal} ml kristaloid I.V. verilir.\n\nMannitol Uygulaması: %20'lik Mannitolden ${mannitolliq.toFixed(1)} ml (${mannitolmg} gr) karışıma eklenir.\n\nTakip: Elektrolit dengesi ve vücut ısısı gözlemlenmelidir.`;
    }

    return {
        totalNeed: Math.round(totalNeed),
        resultMessage
    };
};

// src/utils/calculators.js

export const HEMO_RANGES = {
    cat: {
        WBC: [5.5, 19.5], LENFOSIT: [1.5, 7.0], GRANULOSIT: [2.0, 12.0], MONOSIT: [0.1, 1.5],
        RBC: [5.0, 10.0], PLT: [150, 600], HTC: [24, 45], MCHB: [13, 20], HB: [9, 15], MCV: [39, 55]
    },
    dog: {
        WBC: [6.0, 17.0], LENFOSIT: [1.0, 4.8], GRANULOSIT: [3.0, 12.0], MONOSIT: [0.2, 1.5],
        RBC: [5.5, 8.5], PLT: [200, 500], HTC: [37, 55], MCHB: [19.5, 24.5], HB: [12, 18], MCV: [60, 77]
    }
};

export const getStatus = (species, key, value) => {
    const range = HEMO_RANGES[species][key];
    if (value < range[0]) return "Düşük";
    if (value > range[1]) return "Yüksek";
    return "Normal";
};

export const evaluateDiagnosis = (species, statuses) => {
    const results = { wbc: [], rbc: [] };
    const { WBC, LENFOSIT, GRANULOSIT, MONOSIT, RBC, PLT, HTC, HB, MCV } = statuses;

    // Çakışmayı önlemek için kontrol bayrakları (Flags)
    let wbcKompleksBulundu = false;
    let rbcKompleksBulundu = false;

    // --- WBC TANI MANTIĞI ---

    // 1. Kompleks (Çoklu) Şartlar
    if (WBC === "Yüksek" && (LENFOSIT === "Yüksek" || GRANULOSIT === "Yüksek" || MONOSIT === "Yüksek")) {
        results.wbc.push("Sistemik Enfeksiyon");
        wbcKompleksBulundu = true;
    } else if (WBC === "Düşük" && LENFOSIT === "Düşük" && GRANULOSIT === "Düşük") {
        const msg = species === "cat" 
            ? "Immunsupresyon; genetik faktörlere bağlı, FeLV, FIP veya çoklu organ yetmezliğine bağlı olarak gerçekleşebilir."
            : "Immunsupresyon; genetik faktörlere bağlı, viral etkenler veya çoklu organ yetmezliği.";
        results.wbc.push(msg);
        wbcKompleksBulundu = true;
    } else if (WBC === "Yüksek" && LENFOSIT === "Yüksek" && (GRANULOSIT === "Normal" || GRANULOSIT === "Yüksek")) {
        results.wbc.push("Viral Enfeksiyon; FCOV(Enterik Form), FHP-1, FCV olabilir.");
        wbcKompleksBulundu = true;
    } else if (WBC === "Yüksek" && LENFOSIT === "Normal" && GRANULOSIT === "Yüksek") {
        results.wbc.push("Bakteriyel Enfeksiyon veya apse olabilir.");
        wbcKompleksBulundu = true;
    } else if ((WBC === "Normal" || WBC === "Düşük") && LENFOSIT === "Düşük") {
        results.wbc.push("Viral Enfeksiyon; FIPV, FeLV, FPV veya şiddetli stress olabilir.");
        wbcKompleksBulundu = true;
    }

    // Monosit artışı özel bir durum olduğu için kompleksten bağımsız değerlendirilir
    if (MONOSIT === "Yüksek") {
        results.wbc.push("Kronik veya Persiste Enfeksiyon olabilir.");
    }

    // 2. Tekli Şartlar (Eğer hiçbir kompleks tanı eşleşmediyse çalışır)
    if (!wbcKompleksBulundu) {
        if (WBC === "Düşük") {
            results.wbc.push("Lökopeni: Olası viral enfeksiyon başlangıcı veya bağışıklık baskılanması şüphesi.");
        } else if (WBC === "Yüksek") {
            results.wbc.push("Lökositoz: Genel enfeksiyon, inflamasyon veya stres reaksiyonu.");
        } else if (LENFOSIT === "Yüksek") {
            results.wbc.push("Lenfositoz: Kronik enfeksiyon veya hücresel bağışıklık yanıtı olabilir.");
        } else if (GRANULOSIT === "Yüksek") {
            results.wbc.push("Granülositoz: Erken evre enfeksiyon veya stres tablosu.");
        }
    }


    // --- RBC / ERİTROSİT TANI MANTIĞI ---

    // 1. Kompleks (Çoklu) Şartlar
    if (RBC === "Yüksek" && HTC === "Yüksek") {
        results.rbc.push("Dehidrasyon");
        rbcKompleksBulundu = true;
    } else if (RBC === "Düşük" && HTC === "Düşük" && HB === "Yüksek" && MCV === "Yüksek") {
        results.rbc.push("Damar içi hemoliz, zehirlenme şüpheli");
        rbcKompleksBulundu = true;
    } else if (RBC === "Düşük" && HTC === "Düşük" && HB === "Düşük" && MCV === "Düşük") {
        results.rbc.push("B12, Folikasit, Demir eksikliğine bağlı anemi, hemolitik anemiler, Kronik böbrek yetmezliği şüpheli.");
        rbcKompleksBulundu = true;
    } else if (RBC === "Düşük" && HTC === "Düşük" && HB === "Düşük" && (MCV === "Normal" || MCV === "Yüksek")) {
        results.rbc.push("Kronik böbrek yetmezliği, kronik damar içi hemoliz");
        rbcKompleksBulundu = true;
    }

    // MCV ve PLT bağımsız klinik belirteçler olduğu için her zaman kontrol edilir
    if (MCV === "Yüksek") {
        results.rbc.push("Olgunlaşmamış Eritrosit sayısı yüksek (Makrositoz)");
    } else if (MCV === "Düşük") {
        results.rbc.push("Olgunlaşmamış Eritrosit sayısı düşük, kemik iliğini baskılayan bir hastalık (FeLV, FPV vb.) veya zehirlenme olabilir");
    }

    if (PLT === "Yüksek") {
        results.rbc.push("Damar içi hemoliz, iç kanama veya yaralanma olabilir.");
    } else if (PLT === "Düşük") {
        results.rbc.push("Trombositopeni: Kronik damar içi hemoliz, pıhtılaşma bozukluğu olabilir.");
    }

    // 2. Tekli Şartlar (Eğer hiçbir kompleks RBC tanısı eşleşmediyse çalışır)
    if (!rbcKompleksBulundu) {
        if (HTC === "Yüksek" || HB === "Yüksek") {
            results.rbc.push("Hemokonsantrasyon: Dehidrasyon şüphesi (RBC normal görünse bile sıvı kaybı olabilir).");
        } else if (RBC === "Düşük" || HTC === "Düşük" || HB === "Düşük") {
            results.rbc.push("Anemi Şüphesi: Serideki değerlerden en az biri düşük, kan tablosu takibi önerilir.");
        } else if (RBC === "Yüksek") {
            results.rbc.push("Polisitemi Şüphesi veya Hafif Dehidrasyon.");
        }
    }

    return results;
};